'use strict';

var namespace = 'autocomplete:';

import { error, mixin, Event } from '../common/utils.js';
import { element } from '../common/dom.js';

// constructor
// -----------

function EventBus(o) {
  if (!o || !o.el) {
    error('EventBus initialized without el');
  }

  this.$el = element(o.el);
}

// instance methods
// ----------------

mixin(EventBus.prototype, {

  // ### public

  trigger: function(type, suggestion, dataset, context) {
    var event = Event(namespace + type);
    this.$el.trigger(event, [suggestion, dataset, context]);
    return event;
  }
});

export default EventBus;
